// /**
//  * Orders - list
//  */

// React
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBuilder from '../../utils/headerBuilder';
// Context
import AuthContext from '../../authContext';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  Button,
  Checkbox,
  Typography,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
  CircularProgress,
  Grid,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiFileDocumentOutline,
  mdiPencilOutline,
  mdiHistory,
  mdiAccountArrowLeftOutline,
  mdiCubeSend,
  mdiBarcode,
  mdiPostOutline,
  mdiPlusBoxMultipleOutline,
} from '@mdi/js';

// Components
import Can from '../../components/Can';

// Rules
import {
  rulesOrderStatus,
  rulesPostOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import {
  translateOrderStatus,
  checkMatchMedia,
  translatePostOrderStatus,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { PostOrder } from './interfaces';
import List from './usersList';

type Data = PostOrder;
type Props = {
  data: any;
  users: object;
  loading: boolean;
  handleConfirmCanceleBox: (id: number) => void;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
  handleOpenUpdatePostOrderStatus: any;
  handleOpenChangeType: (id: number) => void;
};
type Ord = 'asc' | 'desc';

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 650,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    title: {
      // flex: '1 1 100%',
    },
  })
);

interface EnhancedTableToolbarProps {
  numSelected: number;
  setOpenChangeStatus: any;
  selected: any;
  data: any;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const { numSelected, selected, data } = props;

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} انتخاب
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [selected, setSelected] = React.useState<string[]>([]);
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);
  const [selectedOperator, setSelectedOperator] = useState(0);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectOperator = (event: { target: HTMLInputElement }) => {
    const { target } = event;
    setSelectedOperator(+target.value);
  };

  const changeStatusOrder = () => {
    props.changeStatusOrderWhitId({
      ids: selected,
      operatorId: selectedOperator,
      description: null,
    });
  };

  const isSelected = (id: string) => props.selectedItems.indexOf(id) !== -1;

  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        numSelected={props.selectedItems.length}
        setOpenChangeStatus={setOpenChangeStatus}
        selected={props.selectedItems}
        data={props.data}
      />
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <HeaderBuilder
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
              numSelected={props.selectedItems.length}
              onSelectAllClick={props.selectAll}
              filterVal={props.filterVal}
              onFilterValue={(filtervalues: any) => {
                props.onFilterValue(filtervalues);
              }}
              head={props.head}
              checkbox={true}
              removeFilterHandler={props.removeFilterHandler}
              haveAction={true}
              filterLabelTranslator={props.filterLabelTranslator}
            />

            <TableBody>
              {stableSort(props.data, getComparator(order, orderBy))
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  let color = '';
                  let backgroundColor = '';

                  switch (true) {
                    case row.orderStatus === 'UNLOADED' ||
                      row.orderStatus === 'PACKAGED' ||
                      row.orderStatus === 'BUNDLED' ||
                      row.orderStatus === 'ASSIGNED':
                      backgroundColor = '#d1e8fa';
                      color = '#283c74';
                      break;
                    case row.orderStatus === 'CANCELLED' ||
                      row.orderStatus === 'RETURNING':
                      backgroundColor = '#fdd1cc';
                      color = '#611a15';
                      break;
                    case row.orderStatus === 'LOADED' ||
                      row.orderStatus === 'DELIVERED':
                      backgroundColor = '#d7fcd7';
                      color = '#1e4659';
                      break;
                  }

                  return (
                    <TableRow
                      key={index}
                      hover
                      role="checkbox"
                      style={{ backgroundColor: backgroundColor }}
                      aria-checked={isSelected(row.id)}
                      tabIndex={-1}
                      selected={isSelected(row.id)}
                    >
                      <StyledTableCell padding="checkbox">
                        <Can
                          role={authContext.user.role}
                          perform="orders:changeOrderStatus"
                          yes={() => (
                            <Checkbox
                              key={index}
                              onClick={event =>
                                props.selectItem(row.id, row.orderStatus)
                              }
                              checked={isSelected(row.id)}
                              inputProps={{ 'aria-labelledby': labelId }}
                            />
                          )}
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ color: color }}
                        data-cy="row-id"
                      >
                        {row.orderId}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ color: color }}
                        data-cy="row-id"
                      >
                        {row.id}
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color }}
                      >
                        {row.partnerName}
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color }}
                      >
                        {row.customerName}
                      </StyledTableCell>
                      {/* <TableCell align="center" style={{color: color}}>{row.trackingCode}</TableCell> */}
                      {/* <StyledTableCell align="center" style={{color: color}}>
                        {row.customerNationalCode}
                      </StyledTableCell> */}
                      {/*                      <Can
                        role={authContext.user.role}
                        perform="orders:list:centerName"
                        yes={() => (
                          <StyledTableCell align="center" style={{color: color}}>
                            {row.centerName}
                          </StyledTableCell>
                        )}
                      />*/}

                      <StyledTableCell align="center" style={{ color: color }}>
                        <span>
                          {jMoment(row.orderDeliveryDate, 'YYYY/M/D')
                            .locale('fa')
                            .format('jYY/jMM/jDD')}
                        </span>
                        &nbsp; &nbsp;- &nbsp; &nbsp;
                        <span>
                          {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH')}
                        `}
                          {`تا ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH')}`}
                        </span>
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ color: color }}>
                        <Can
                          role={authContext.user.role}
                          perform="orders:changeOrderStatus"
                          yes={() => (
                            <FormControl style={{ width: '100%' }}>
                              <Icon
                                path={mdiPencilOutline}
                                size={1}
                                className={classes.changStatusIcon}
                              />
                              <Select
                                className={classes.changStatusBox}
                                fullWidth
                                name={`status${index}`}
                                multiple
                                id={row.id}
                                value={[{}]}
                                disabled={
                                  row.orderStatus !== 'PACKAGED' &&
                                  row.orderStatus !== 'DELIVERED_TO_POST'
                                }
                                IconComponent={() => null}
                                renderValue={() => (
                                  <span className={classes.renderValue}>
                                    {translateOrderStatus(row.orderStatus)}
                                  </span>
                                )}
                              >
                                <RadioGroup
                                  className={classes.radioGroup}
                                  aria-label={`status${index}`}
                                  name={`status${index}`}
                                  value={'item'}
                                  onChange={(
                                    e: React.ChangeEvent<{ value: unknown }>
                                  ) =>
                                    props.handleOpenConfirmUpdateState({
                                      id: row.orderId,
                                      body: `${e.target.value}`,
                                    })
                                  }
                                >
                                  {rulesOrderStatus[row.orderStatus]
                                    ?.filter(
                                      el =>
                                        el === 'DELIVERED_TO_POST' ||
                                        el === 'PACKAGED' ||
                                        el === 'NOT_DELIVERED' ||
                                        el === 'RETURNED'
                                    )
                                    ?.map((item: any, index: number) => (
                                      <FormControlLabel
                                        className={classes.radioGroupItem}
                                        key={index}
                                        checked={row.orderStatus === item}
                                        value={item}
                                        disabled={
                                          item !== 'DELIVERED_TO_POST' &&
                                          item !== 'NOT_DELIVERED' &&
                                          item !== 'RETURNED'
                                        }
                                        control={<Radio />}
                                        label={translateOrderStatus(item)}
                                      />
                                    ))}
                                </RadioGroup>
                              </Select>
                            </FormControl>
                          )}
                          no={() => {
                            return (
                              <span>
                                {translateOrderStatus(row.orderStatus)}
                              </span>
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <FormControl style={{ width: '100%' }}>
                          <Icon
                            path={mdiPencilOutline}
                            size={1}
                            className={classes.changStatusIcon}
                          />
                          <Select
                            className={classes.changStatusBox}
                            fullWidth
                            name={`status${index}`}
                            multiple
                            id={row.id}
                            value={[{}]}
                            IconComponent={() => null}
                            renderValue={() => (
                              <span className={classes.renderValue}>
                                {translatePostOrderStatus(row.postOrderStatus)}
                              </span>
                            )}
                          >
                            <RadioGroup
                              className={classes.radioGroup}
                              aria-label={`status${index}`}
                              name={`status${index}`}
                              value={'item'}
                              onChange={(
                                e: React.ChangeEvent<{ value: unknown }>
                              ) =>
                                props.handleOpenUpdatePostOrderStatus({
                                  id: row.id,
                                  body: `${e.target.value}`,
                                })
                              }
                            >
                              {rulesPostOrderStatus[row.postOrderStatus]?.map(
                                (item: any, index: number) => (
                                  <FormControlLabel
                                    className={classes.radioGroupItem}
                                    key={index}
                                    checked={row.orderStatus === item}
                                    value={item}
                                    control={<Radio />}
                                    label={translatePostOrderStatus(item)}
                                  />
                                )
                              )}
                            </RadioGroup>
                          </Select>
                        </FormControl>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <div>
                          <Link to={`/orders/${row.orderId}`}>
                            <IconButton
                              aria-label="details"
                              size="small"
                              title="جزئیات سفارش"
                              data-cy="details"
                            >
                              <Icon
                                path={mdiFileDocumentOutline}
                                size={1}
                                color={theme.palette.green.main}
                              />
                            </IconButton>
                          </Link>
                          <IconButton
                            aria-label="changeAction"
                            size="small"
                            title="تغییر نوع ارسال سفارش"
                            data-cy="changeAction"
                            disabled={row?.status === 'DELIVERED_TO_POST'}
                            onClick={() =>
                              props.handleOpenChangeType(row.orderId)
                            }
                          >
                            <Icon
                              path={mdiPlusBoxMultipleOutline}
                              size={1}
                              color={
                                row?.status === 'DELIVERED_TO_POST'
                                  ? theme.palette.gray.main
                                  : theme.palette.orange.main
                              }
                            />
                          </IconButton>
                          {/* <Link
                            to={
                              row.orderStatus === 'DELIVERED_TO_POST' &&
                              row.postOrderStatus === 'DONE'
                                ? '#'
                                : `/post-orders/${row.id}/send`
                            }
                          >
                            <IconButton
                              aria-label="details"
                              size="small"
                              title="عملیات پستی"
                              data-cy="details"
                              disabled={
                                row.orderStatus === 'DELIVERED_TO_POST' &&
                                row.postOrderStatus === 'DONE'
                              }
                            >
                              <Icon
                                path={mdiCubeSend}
                                size={1}
                                color={
                                  row.orderStatus === 'DELIVERED_TO_POST' ||
                                  row.postOrderStatus === 'DONE'
                                    ? theme.palette.gray.main
                                    : theme.palette.info.main
                                }
                              />
                            </IconButton>
                          </Link> */}
                          <Can
                            role={authContext.user.role}
                            perform="/post-orders/receipts/:id"
                            yes={() => (
                              <Link
                                to={`/post-orders/receipts/${row.id}`}
                                target="_blank"
                              >
                                <IconButton
                                  aria-label="details"
                                  size="small"
                                  title="مشاهده صورت حساب پست"
                                  data-cy="details"
                                >
                                  <Icon
                                    path={mdiBarcode}
                                    size={1}
                                    color={theme.palette.orange.dark}
                                  />
                                </IconButton>
                              </Link>
                            )}
                          />
                          <IconButton
                            aria-label="print"
                            size="small"
                            title="چاپ لیبل پستی"
                            data-cy="print"
                            disabled={!row.barcode}
                            onClick={() => {
                              const win = window.open(
                                `/post-print-labels/${row.id}`,
                                '_blank'
                              )!;
                              win.focus();
                            }}
                          >
                            <Icon
                              path={mdiPostOutline}
                              size={1}
                              color={
                                row.barcode
                                  ? theme.palette.orange.main
                                  : theme.palette.orange.dark
                              }
                            />
                          </IconButton>
                          {/* <Can
                            role={authContext.user.role}
                            perform="orders:history"
                            yes={() => (
                              <Link to={`/orders/${row.orderId}/allLogs`}>
                                <IconButton size="small" title="تاریخچه سفارش">
                                  <Icon path={mdiHistory} size={1} />
                                </IconButton>
                              </Link>
                            )}
                          /> */}
                          <Can
                            role={authContext.user.role}
                            perform="order:assign"
                            yes={() => (
                              <Link to={`/assign-order/${row.id}`}>
                                <IconButton size="small" title="اختصاص سفارش">
                                  <Icon
                                    color="#b297a7"
                                    path={mdiAccountArrowLeftOutline}
                                    size={1}
                                  />
                                </IconButton>
                              </Link>
                            )}
                          />
                          {/*<Can
                            role={authContext.user.role}
                            perform="orders:cancelOrders"
                            yes={() => (
                              <IconButton
                                aria-label="cancele"
                                title={
                                  row.orderStatus === 'CANCELLED'
                                    ? 'لغو شده'
                                    : 'لغو سفارش'
                                }
                                size="small"
                                style={{pointerEvents: 'fill'}}
                                disabled={row.orderStatus === 'CANCELLED'}
                                onClick={() => handleClickOpen(row.id)}
                              >
                                <Icon
                                  path={mdiClose}
                                  size={1}
                                  color={
                                    row.orderStatus !== 'CANCELLED'
                                      ? theme.palette.error.main
                                      : theme.palette.gray.main
                                  }
                                />
                              </IconButton>
                            )}
                          />*/}
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Dialog
        fullWidth
        open={openChangeStatus}
        onClose={() => setOpenChangeStatus(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {'تغییر وضعیت کلی سفارش ها به تخصیص داده شده'}
        </DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {'اپراتور مورد نظر را انتخاب کنید'}
            </FormLabel>
            <Grid
              container
              xs={12}
              style={{ marginTop: '20px', marginRight: 0, marginLeft: 0 }}
            >
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <List
                  onSelectOperator={handleSelectOperator}
                  selectedOperator={selectedOperator}
                  data={props.users}
                />
              )}
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenChangeStatus(false)}
            variant="contained"
            color="primary"
          >
            {'خیر'}
          </Button>

          <Button
            onClick={changeStatusOrder}
            color="primary"
            variant="outlined"
            disabled={!selectedOperator}
          >
            {'تخصیص اپراتور'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
